<!--
 * @Author: 史金波
 * @Date: 2021-12-14 09:04:18
 * @LastEditors: 史金波
 * @Description: 
 * @LastEditTime: 2021-12-15 03:48:34
 * @FilePath: \saas-perform-web\src\views\account\accountlist.vue
-->
<template>
	<div>
		<el-breadcrumb separator-class="el-icon-arrow-right">
		  <el-breadcrumb-item :to="{ path: '/dashboad' }">首页</el-breadcrumb-item>
		  <el-breadcrumb-item>账户管理</el-breadcrumb-item>
		</el-breadcrumb>
		<div>
    <el-row :gutter="20" style="margin-top: 4.0rem;">
      <el-col :span="4">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>预付款</span>
          </div>
					<div style=" margin-top: 1.3rem;margin-buttom: 0.9rem;text-align:center;font-weight:320;">
							{{accountInfo.amount}}
					</div>
					<div style="margin-top: 2.9rem;text-align:center;">
							<el-button type="primary"  @click="gotoRecharge()" :loading="logining">充值</el-button>
							<el-button type="primary"  @click="gotoRechargeOrderlist()" :loading="logining">明细</el-button>
					</div>
        </el-card>
      </el-col>
    </el-row>
  </div>
	</div>
</template>

<script>
	import {searchAccountInfoApi} from "../../api/account/accountApi.js"
	export default {
		data(){
			return {
				tenantId:"",
				accountInfo:{
					amount:''
				}
			}
		},
		methods:{
			gotoRecharge(){
				this.$router.push("/account/accountrecharge")
			},
			gotoRechargeOrderlist(){
				this.$router.push("/account/accountorders")
			}
		},
		created(){
			searchAccountInfoApi().then(res=>{
				console.log(res)
				this.accountInfo.amount = res.data.data.amount
			})
		}
	}
</script>

<style>
  .el-row {
    margin-bottom: 20px;
    &:last-child {
      margin-bottom: 0;
    }
  }
  .el-col {
    border-radius: 4px;
  }
  .bg-purple-dark {
    background: #99a9bf;
  }
  .bg-purple {
    background: #d3dce6;
  }
  .bg-purple-light {
    background: #e5e9f2;
  }
  .grid-content {
    border-radius: 4px;
    min-height: 36px;
  }
  .row-bg {
    padding: 10px 0;
    background-color: #f9fafc;
  }
</style>



// WEBPACK FOOTER //
// src/views/account/accountlist.vue